<template>
  <div class="section-scene top">
    <div class="mask">
      <div class="mask-l"></div>
      <div class="mask-r"></div>
    </div>
    <!-- 背景 -->
    <div class="background">
      <!-- <transition name="fadeDown"> -->
      <img v-show="bgIndex == 0" :src="static_img_url + 'pic/index/bg-1.jpg'" class="scale">
      <img v-show="bgIndex == 1" :src="static_img_url + 'pic/index/bg-2.jpg'" class="bg-2 moveLeft">
      <img v-show="bgIndex == 2" :src="static_img_url + 'pic/index/bg-3.png'" class="bg-3 moveDown">
      <!-- </transition> -->
    </div>
    <!-- 左侧logo -->
    <div class="vb-logo">
      <div>
        <img :src="static_img_url + 'pic/index/logo1.png'" class="logo1">
      </div>
      <div>
        <img :src="static_img_url + 'pic/index/future.png'" class="logo2">
      </div>
      <div>
        <img :src="static_img_url + 'pic/index/health-care.png'" class="logo3">
      </div>
      <div>
        <img :src="static_img_url + 'pic/index/vb100.png'" class="logo4">
      </div>
      <div>
        <img :src="static_img_url + 'pic/index/logo.png'" class="logo5">
        <img :src="static_img_url + 'pic/index/vcbeat.png'" class="logo5">
        <img :src="static_img_url + 'pic/index/vcResearch.png'" class="logo5">
      </div>
    </div>
    <!-- 滑块 -->
    <div class="s-postion">
      <Slider :showIcon="showIcon" :data="sliderData" :exit="exitSlider" @getAvtiveIndex="getAvtiveIndex"></Slider>
    </div>
    <!-- 离开背景 -->
    <div class="leave-bg"></div>
  </div>
</template>

<script>
import Slider from '../../components/slider/slider'
import { anima_mixins } from 'js/anima_mixins.js'
import { timeoutSync } from 'js/common.js'
export default {
  mixins:[anima_mixins],
  data(){
    return {
      static_img_url: process.env.VUE_APP_CDN,
      defaultPage: 0,
      bgIndex: 0,

      showIcon: 'number',
      exitSlider: true,
      sliderData:[
        {
          title: '未来医疗100强',
          summary: `有一股力量，正在改变未来医疗的格局<br>
              他们在技术升级的基础上实现服务的跃迁<br>
              他们在观念转变的前提下悄然改变我们的生活<br>
              他们来自于野蛮生长的创新领域<br>
              他们突破传统的藩篱建造新规则<br>
              他们就是中国未来医疗产业的核心力量`
        },
        {
          title: '未来医疗100强榜',
          summary: `创立于2015年的未来医疗100强榜是由动脉网、<br>
              蛋壳研究院推出的国内第一个针对非上市企业<br>
              的创新医疗领域榜单，旨在遴选真正代表未来<br>
              医疗的中国创新医疗者，发现我国未来医疗产<br>
              业的核心力量，推动健康医疗产业的创新变革<br>
              进程。`
        },
        {
          title: '未来医疗100强大会',
          summary: `大会自2016年创办以来，累积参与企业超过<br>
                5000家，其中上市企业超过300家，投资机构<br>
                超过1000家，参会人数超过3万人次，邀请演<br>
                讲嘉宾超过500位，已经成为是中国医健创新<br>
                行业中规模最大、信息量最大的产业与资本融<br>
                合的盛会。`
        }
      ]
    }
  },
  async mounted(){
    this.exitSlider = false
    await timeoutSync(() => {
      this.$emit('setLock', true)
    },1400)
  },
  components:{
    Slider
  },
  methods:{
    getAvtiveIndex(data){
      this.bgIndex = data.activeIndex
    },
    
    downEnter(){},
    async upEnter(){
      // console.log('index:上 我进来了')
      await timeoutSync(() => {
        $('.leave-bg').removeClass('exit-bg')
      },100)
      $('.vb-logo').css('opacity','1')
      this.$emit('setLock', true)
      this.exitSlider = false
    },

    async downLeave(){
      // console.log('index:下 我离开了')
      this.exitSlider = true
      $('.vb-logo').css('opacity','0')
      await timeoutSync(() => {
        $('.leave-bg').addClass('exit-bg')
      },600)
      await timeoutSync(() => {
        this.$emit('setActivePage',this.nextPage)
      },600)
    },
    upLeave(){},
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus';
@import '~styles/animation.stylus';
  
*{transition: all .8s}
.top
  .background
    transition all .6s
    opacity 1
    .bg-2
      width 120% !important
      height 100%
    .bg-3
      width 100%
      height 120% !important
  .mask
    position absolute
    left 0
    right 0
    top 0
    bottom 0
    z-index -1
    display flex
    flex-direction row
    .mask-l,.mask-r
      width 50%
      height 100%
    .mask-l
      background: linear-gradient(to right, rgba(0,0,0,.56) , rgba(0,0,0,0));
    .mask-r
      background: linear-gradient(to right, rgba(0,0,0,0) , rgba(0,0,0,.56));
  .vb-logo
    width 60vw
    height 100vh
    padding px2vh(160) px2vw(80) 0 px2vw(80)
    display inline-flex
    flex-direction column
    opacity 1
    transition all .6s
    >div
      position relative
      height px2vh(130)
      overflow hidden
      img 
        animation: slideInUp 1.5s ease
      .logo1
        height px2vh(80)
      .logo2
        height px2vh(60)
        // animation-delay: 100ms
      .logo3
        height px2vh(60)
        // animation-delay: 200ms
      .logo4
        height px2vh(60)
        // animation-delay: 300ms
      .logo5:nth-child(1)
        height px2vh(40)
      .logo5:nth-child(2)
        height px2vh(40)
        margin-left 30px
      .logo5:nth-child(3)
        height px2vh(40)
        margin-left 20px
  .s-postion
    position absolute
    right: px2vw(80)
    bottom: px2vh(30)
  .leave-bg
    position absolute
    z-index 20
    left 0
    right 0
    top 0
    bottom 0
    background:linear-gradient(-45deg,rgba(214,162,77,1),rgba(255,215,149,1));
    transition all .6s
    transform translateY(100%)
    &.exit-bg
      transform translateY(0)
</style>